import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** 合并 className，处理 Tailwind 冲突 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** 格式化大数字（1234 → 1,234；12345 → 1.2万；1234567 → 123.5万） */
export function formatNumber(n: number | null | undefined): string {
  if (n == null) return '—'
  if (n < 1000) return n.toString()
  if (n < 10_000) return n.toLocaleString('zh-CN')
  if (n < 100_000_000) {
    return `${(n / 10_000).toFixed(n < 100_000 ? 1 : 0)}万`
  }
  return `${(n / 100_000_000).toFixed(1)}亿`
}

/** 格式化百分比（0.85 → 85%；保留 1 位小数） */
export function formatPercent(n: number | null | undefined, digits = 1): string {
  if (n == null) return '—'
  return `${(n * 100).toFixed(digits)}%`
}

/** 格式化时长（秒 → "2:52" / "0:30" / "1m"） */
export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null || seconds <= 0) return '—'
  const m = Math.floor(seconds / 60)
  const s = Math.floor(seconds % 60)
  if (m === 0) return `${s}秒`
  return s > 0 ? `${m}:${String(s).padStart(2, '0')}` : `${m}m`
}

/** 相对时间（"3 天前"） */
export function timeAgo(ts: number | string | Date): string {
  const date = typeof ts === 'object' ? ts : new Date(ts)
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000)
  if (seconds < 60) return `${seconds}秒前`
  if (seconds < 3600) return `${Math.floor(seconds / 60)}分钟前`
  if (seconds < 86_400) return `${Math.floor(seconds / 3600)}小时前`
  if (seconds < 604_800) return `${Math.floor(seconds / 86_400)}天前`
  return date.toLocaleDateString('zh-CN')
}

/** 健康度分档颜色 — 微信风(绿/橙/红) */
export function healthColor(score: number): string {
  if (score >= 80) return '#07C160' // 微信绿 — 健康
  if (score >= 60) return '#FA9D3B' // 警示橙 — 良好
  if (score >= 40) return '#FA9D3B' // 警示橙 — 预警
  return '#FA5151' // 红 — 不健康
}
